import React from "react";
import {Box} from '@mui/material'
const NoItemSelected = () => {
  return (
    <>
      <div style={{ marginTop: "20%" }}>
        <Box  sx={{display:'flex',justifyContent:"center" ,marginBottom:"5px"}}>
          <span className="d-block head-title-3">No item selected</span>
        </Box>
        <Box sx={{display:'flex',justifyContent:"center"}}>
          <span className="d-block gray-span">
            Select an item from the left panel to preview its details here.
          </span>
        </Box>
      </div>
    </>
  );
};

export default NoItemSelected;
